// extracted by mini-css-extract-plugin
export default {"banner":"index_banner_umjE7","bannerPic":"index_bannerPic_jaPFs"};